import actionTypes from 'constants/actionTypes';

import { IncentiveOfferType } from 'modules/incentivesMarket/types';
import { AddIncentiveOfferPageProvider } from '../pages/AddIncentiveOffer/context/AddIncentiveOfferPageContext';
import AddIncentiveOfferPage from '../pages/AddIncentiveOffer';

const EditSellIncentiveOfferPageContainer = () => (
  <AddIncentiveOfferPageProvider
    incentiveOfferType={IncentiveOfferType.SELL}
    actionType={actionTypes.EDIT}
  >
    <AddIncentiveOfferPage />
  </AddIncentiveOfferPageProvider>
);

export default EditSellIncentiveOfferPageContainer;
